import React, { useState, useEffect } from 'react';
import { Color } from '../../const/Const';
import FieldItemListGridGet from '../FieldItemListGridGet/FieldItemListGridGet';
import { ReactComponent as DeleteIconColor } from '../../svg/deleteIcon.svg';

const GridMultiSelect = (props) => {

    const [initData, setInitData] = useState(
        {
            key: null,
            text: null,
            rowstate: 0
        }
    );

    const [data, setData] = useState([{ ...initData }]);

    const getExistData = () => {
        let tData = [{ ...initData }];
        if (props?.defaultValue?.length > 0) {
            if (props.defaultValue.map(r => r.rowstate).indexOf(0) < 0) {
                tData = props.defaultValue.concat([{ ...initData }]);
            } else {
                tData = props.defaultValue;
            }

        }
        tData?.map(r => {
            if (r.text) {
                r.name = r.text
            }
        });
        setData(tData);
    }

    useEffect(() => {
        getExistData();
    }, [props.defaultValue])

    const onEdit = (p_index, p_field, p_value, p_fieldname, p_valuename, p_full) => {
        let tData = [...data];
        tData[p_index][p_field] = p_value;
        tData[p_index][p_fieldname] = p_valuename;
        tData[p_index].rowstate = 1;

        setData(tData);
        if (props.onChanged) {
            props.onChanged(tData, '', props.keyfield);
        }
    }

    const onDelete = (p_index) => {
        let tData = [...data];

        tData.splice(p_index, 1);

        setData(tData);
        if (props.onChanged) {
            props.onChanged(tData, '', props.keyfield);
        }
    }

    return (
        <div>
            <div style={{ display: 'flex' }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{props.title}</div>{props.required && (<div style={{ color: Color.red }}>*</div>)}
            </div>
            {data?.map((r, index) => {
                let vBorder = {
                    borderBottom: '1px solid #EDEBE9'
                };
                if (r.rowstate == 0) {
                    vBorder = {};
                }
                return (
                    <div key={index} style={{ display: 'flex', alignItems: 'center', paddingTop: 6, ...vBorder }}>
                        {r.rowstate != 0 ? (
                            <div onClick={() => onDelete(index)} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}><DeleteIconColor /></div>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <DeleteIconColor disable />
                            </div>
                        )}
                        <div style={{ marginLeft: 8, width: '100%' }}>
                            <FieldItemListGridGet onChanged={onEdit} keyfield='key' keyfieldname='text' index={index} defaultValue={[{ key: r.key, name: r.text }]} dataurl={props.dataurl} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default GridMultiSelect;